'use strict';

(function () {
  'use strict';

  angular.module('msProfile').controller('ProfilePageCtrl', ProfilePageCtrl);

  ProfilePageCtrl.$inject = ['$state', 'user', 'providerSvc', 'pane'];

  function ProfilePageCtrl($state, user, providerSvc, pane) {
    var vm = this;
    vm.pane = pane;
    vm.user = user;
    vm.hideTabs = $state.is('profile.iframe');
    vm.codeStatus = user.accessCode.status;
    vm.cobrandingText = user.organization.name;
    vm.currentNavItem = $state.current.name;

    // workaround for md-nav-bar for accessibility
    var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
    navElement.attr('tabindex', '0');

    providerSvc.getPreferences().then(function (prefs) {
      vm.providerPreferences = prefs;
    });

    providerSvc.getHeaderImage().then(function (image) {
      vm.cobranding = image;
    });

    vm.navigatePane = function (state) {
      vm.pane = state;
    };
  }
})();